import styled, { css } from "styled-components";

export const Filters = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  & > * {
    margin: 0 16px 0 0;
  }
`;

export const TRow = styled.tr`
  cursor: pointer;
  height: 56px;
  &:nth-child(even) {
    background: ${props => props.theme.colors.zebraStripe};
  }
`;

export const HTRow = styled.tr`
  & th {
    background: ${props => props.theme.colors.mako};
    border-right: ${props =>
      `1px solid ${props.theme.colors.headerColumnBorder}`};
    color: ${props => props.theme.colors.white};
    font-weight: normal;
    height: 48px;
    position: sticky;
    top: 0;
  }
`;

const sortIconStyle = css`
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  content: "";
  height: 0;
  position: absolute;
  top: 50%;
  bottom: 0;
  right: 8px;
  width: 0;
`;

export const SortTH = styled.th`
  cursor: pointer;

  &::before {
    ${sortIconStyle};

    border-bottom: ${p => `5px solid ${p.theme.colors.white}`};
    display: ${p => (p.sort === "desc" ? "none" : "initial")};
    transform: translateY(-6px);
  }
  &::after {
    ${sortIconStyle};

    border-top: ${p => `5px solid ${p.theme.colors.white}`};
    display: ${p => (p.sort === "asc" ? "none" : "initial")};
    transform: translateY(2px);
  }
`;

export const Table = styled.table.attrs({ className: "fees-table" })`
  border-spacing: 0;
  width: 100%;

  & th {
    padding: 0 20px 0 10px;
    text-align: left;
  }
  & td {
    padding: 0 0 0 10px;
  }
`;

export const TableContainer = styled.div`
  height: 100%;
  overflow: scroll;
  position: absolute;
  width: 100%;
`;

export const ContentContainer = styled.div.attrs({
  className: "fees__content"
})`
  flex: 1;
  position: relative;
`;

export const ActionCell = styled.td`
  text-align: center;

  & > * {
    margin: 0 16px 0 0;
  }
`;

export const RetryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  & > * {
    margin: 24px 0;
  }
`;
